import { render, staticRenderFns } from "./SupplierPaymentRecording.vue?vue&type=template&id=2caf0778"
import script from "./SupplierPaymentRecording.vue?vue&type=script&lang=js"
export * from "./SupplierPaymentRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports